var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.75,
    height: 19.75,
    viewBox: "0 0 14.75 19.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8781",
    "data-name": "\\uC0AC\\uAC01\\uD615 8781",
    width: 14.75,
    height: 19.75,
    fill: "#8c8c8c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8275",
    "data-name": "\\uADF8\\uB8F9 8275",
    transform: "translate(-980 -894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8274",
    "data-name": "\\uADF8\\uB8F9 8274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7651",
    "data-name": "\\uADF8\\uB8F9 7651",
    transform: "translate(980 894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7648",
    "data-name": "\\uADF8\\uB8F9 7648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7647",
    "data-name": "\\uADF8\\uB8F9 7647",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12549",
    "data-name": "\\uD328\\uC2A4 12549",
    d: "M14.375,24.25h-14A.375.375,0,0,1,0,23.857l.7-14.5A.375.375,0,0,1,1.072,9h1.3a.375.375,0,0,1,0,.75H1.429L.768,23.5H13.982L13.321,9.75h-.946a.375.375,0,0,1,0-.75h1.3a.375.375,0,0,1,.375.357l.7,14.5a.375.375,0,0,1-.375.393Z",
    transform: "translate(0 -4.5)",
    fill: "#8c8c8c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_33",
    "data-name": "\\uC120 33",
    d: "M6.625,0h-7A.375.375,0,0,1-.75-.375.375.375,0,0,1-.375-.75h7A.375.375,0,0,1,7-.375.375.375,0,0,1,6.625,0Z",
    transform: "translate(4.25 5.25)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7650",
    "data-name": "\\uADF8\\uB8F9 7650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7649",
    "data-name": "\\uADF8\\uB8F9 7649",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_34",
    "data-name": "\\uC120 34",
    d: "M12.625,0h-13A.375.375,0,0,1-.75-.375.375.375,0,0,1-.375-.75h13A.375.375,0,0,1,13-.375.375.375,0,0,1,12.625,0Z",
    transform: "translate(1.25 15.75)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12550",
    "data-name": "\\uD328\\uC2A4 12550",
    d: "M14.375,8.25A.375.375,0,0,1,14,7.875V3.752a3.049,3.049,0,0,0-3.088-3h-.074a3.049,3.049,0,0,0-3.088,3V7.875a.375.375,0,0,1-.75,0V3.752A3.8,3.8,0,0,1,10.838,0h.074A3.8,3.8,0,0,1,14.75,3.752V7.875A.375.375,0,0,1,14.375,8.25Z",
    transform: "translate(-3.5)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_35",
    "data-name": "\\uC120 35",
    d: "M1.625,0h-2A.375.375,0,0,1-.75-.375.375.375,0,0,1-.375-.75h2A.375.375,0,0,1,2-.375.375.375,0,0,1,1.625,0Z",
    transform: "translate(3.25 8.25)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_36",
    "data-name": "\\uC120 36",
    d: "M1.625,0h-2A.375.375,0,0,1-.75-.375.375.375,0,0,1-.375-.75h2A.375.375,0,0,1,2-.375.375.375,0,0,1,1.625,0Z",
    transform: "translate(10.25 8.25)",
    fill: "#8c8c8c"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBag);
export default __webpack_public_path__ + "static/media/icon_bag.040359baf85777970bc914ae043807c1.svg";
export { ForwardRef as ReactComponent };